import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// Router
import VueRouter from 'vue-router'
import routes from './routes.js'

Vue.use(VueRouter)

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if ( localStorage.getItem('token') == null && to.path != '/' ) next('/')
  else next()
})

// Axios
var endpoint = 'https://roadappapi.ancservizi.it/'
//var endpoint = 'http://192.168.1.31:8000/'
// var endpoint = 'http://localhost:8000/' 

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

axios.defaults.baseURL = endpoint;
axios.defaults.withCredentials = false; // for sessions (not valid for ANCSERVIZI)

axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    if (localStorage.getItem("token")) {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    } else {
      config.headers["Authorization"] = "";
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Tooltip
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

// Modals
import VModal from 'vue-js-modal'
Vue.use(VModal)

// SweetAlert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

// Tag Input
import VoerroTagsInput from '@voerro/vue-tagsinput';
Vue.component('tags-input', VoerroTagsInput);

// VueLayers
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css' // needs css-loader

Vue.use(VueLayers)

// VueLeaflet
import { LMap, LTileLayer, LMarker, LIcon, LGeoJson, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-icon', LIcon);
Vue.component('l-geo-json', LGeoJson);
Vue.component('l-popup', LPopup);

import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import * as firebase from "firebase/app";
import "firebase/messaging"

const firebaseConfig = {
    apiKey: "AIzaSyBn_9Vmb5BJ0Se4elgqytJWG0nAGYn8Rqw",
    authDomain: "roadapp-7872b.firebaseapp.com",
    databaseURL: "https://roadapp-7872b.firebaseio.com",
    projectId: "roadapp-7872b",
    storageBucket: "roadapp-7872b.appspot.com",
    messagingSenderId: "59638300210",
    appId: "1:59638300210:web:80e1bbba13d5e6dd1c862b",
    measurementId: "G-HGNLPZ1SC3"
  };

firebase.initializeApp(firebaseConfig)

Vue.prototype.$messaging = firebase.messaging()
Vue.prototype.$messaging.usePublicVapidKey('BAKJ6BBKhYbLKpy7WvkN_YmGGgbJObBg84wnjFOu3JRyFJKn8QLO7N6xMAJ779OoZLuJveBtlXzhKHMJFrhLGrU')

navigator.serviceWorker.register('/firebase-messaging-sw.js')
  .then((registration) => {
    Vue.prototype.$messaging.useServiceWorker(registration)
  }).catch(err => {
    console.log(err)
  })

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
